import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for D501 (PO Approval)
// ============================================================

export interface PendingItem {
  fd110_01: string;      // 採購單號
  fd110_11: string | null;  // 採購日期 (ISO string)
  fd110_12: string;      // 供應商代碼
  supplier_name: string; // 供應商名稱
  fd110_17: string;      // 業務員代碼 (空白時為採購人員 FD110_31)
  sales_name: string;    // 業務/採購員名稱
  fd110_32: string;      // 部門代碼 (BR-V04 部門授權欄)
  dept_name: string;     // 部門名稱 (FD110_18 優先)
  fd110_24: number;      // 採購金額
  fd110_80: string;      // 核准狀態
  can_approve: boolean;  // 是否可核准
}

export interface QueryResponse {
  items: PendingItem[];
  total: number;
  level: string;
}

export interface ApproveResultItem {
  po_no: string;
  success: boolean;
  message: string;
  new_stat: string;
}

export interface ExecuteResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const d501Api = {
  /** Query pending PO items within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d501/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Execute batch approval for selected PO items */
  async execute(poNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/d501/execute', {
      po_nos: poNos,
    });
    return res.data;
  },
};
